import * as React from 'react';

import { BaseComponent } from './BaseComponent';

const MAX_DOTS: number = 5;

interface SliderDotsState {
    list: Array<unknown>;
    item: unknown;
}

interface SliderDotsProps {
    list?: Array<unknown>;
    item?: unknown;
    max?: number;
}

export class SliderDots extends BaseComponent<SliderDotsProps, SliderDotsState> {
    public componentWillMount(): void {
        this.setState({
            list: this.props.list != null ? this.props.list : [],
            item: this.props.item != null ? this.props.item : null
        });
    }

    public render(): JSX.Element {
        const list: Array<unknown> = this.props.list != null ? this.props.list : this.state.list;
        const item: unknown = this.props.item != null ? this.props.item : this.state.item;
        const max: number = this.props.max != null ? this.props.max : MAX_DOTS;
        if (this.state.list.length > max) {
            const currentIndex: number = Math.max(0, list.indexOf(item));
            return (
                <div className="slider-counter">{currentIndex + 1}/{list.length}</div>
            );
        }
        return (
            <ul className="slick-dots" style={{display: 'block'}}>
                {list.map(this.getDot)}
            </ul>
        );
    }

    protected getDot = (listItem: unknown, index: number): JSX.Element => {
        const item: unknown = this.props.item != null ? this.props.item : this.state.item;
        return (
            <li className={listItem === item ? 'slick-active' : ''} key={index}>
                <button>{index + 1}</button>
            </li>
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SliderDots.tsx